import { Outlet } from 'react-router-dom';
import RequireAuth from './auth/RequireAuth';

export default function App() {
    return (
        <RequireAuth>
            <Outlet />
        </RequireAuth>
    );
}
